import { render, staticRenderFns } from "./TransactionTemp.vue?vue&type=template&id=01ce5c0c"
import script from "./TransactionTemp.vue?vue&type=script&lang=js"
export * from "./TransactionTemp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports